/* eslint-disable */
import { ClipLoader } from "react-spinners";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import ChangeCardForm from "./ChangeCardForm";

function Checkout({ studentPlans, successChange, setSuccessChange }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);

  const studentPlanId = studentPlans.id;
  const currency = studentPlans.studentPlanPayments[0]?.currency;

  if (currency == "USD") {
    var stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE_USD);
  }
  if (currency == "BRL") {
    var stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE_BRL);
  }

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_LINK_API}/subscriptions-stripe/create-setup-intent-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ studentPlanId, action: "changeCard" }),
    })
      .then((res) => res.json())
      .then((res) => setClientSecret(res.result.items[0].client_secret))
      .then(() => setLoading(false));
  }, []);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret: clientSecret,
    currency: currency.toLowerCase(),
    appearance,
  };

  return (
    <div className="App">
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", marginBottom: 12 }}
        >
          <ClipLoader color="#004fff" />
        </div>
      ) : (
        <>
          {clientSecret && (
            <Elements options={options} stripe={stripePromise}>
              <ChangeCardForm
                t={t}
                clientSecret={clientSecret}
                studentPlanId={studentPlanId}
                successChange={successChange}
                setSuccessChange={setSuccessChange}
              />
            </Elements>
          )}
        </>
      )}
    </div>
  );
}

export default Checkout;
